<script setup lang="ts">
import { warningSign } from '@/components/icons/icons';
</script>

<template>
  <div class="prototypeWarning">
    <v-icon class="mr-2" :icon="warningSign" size="18" />
    <span class="text-body-2">{{ $t('NotForClinicalUseTitle') }}</span>
  </div>
</template>

<style lang="scss" scoped>
@use 'vuetify/lib/styles/tools/_elevation';
@use '@/styles/variables' as *;

.prototypeWarning {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  max-width: 600px;
  min-width: 300px;
  height: 40px;
  padding: 0 16px;
  background-color: rgba(var(--v-theme-warning), 0.35);
  color: rgb(var(--v-theme-warning-darken-2));
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  z-index: 9;

  @include elevation.elevation(4);

  :deep(.text-body-2) {
    font-weight: $fontweight_semibold !important;
    font-size: 16px !important;
  }
}
</style>
